import axios from 'axios';
import dshStore from './model';

export function getEnvironment() {
    axios.get('/zhgd/envTab/deviceInfo?pageNo=1&pageSize=10')
        .then((data) => {
            const deviceList = data.result || [];
            if(deviceList.length) {
                axios.get(`/zhgd/envTab/deviceArgsInfo?pageNo=1&pageSize=100&deviceId=${deviceList[0].id}`)
                    .then((res) => {
                        dshStore.setEnvironments(res.result || []);
                    })
            }
        })
        .catch((e) => console.log(e));
}

export function getSensor() {
    axios.get('/zhgd/index/sensor')
        .then((data) => {
            dshStore.setSensors(data.result);
        })
        .catch((e) => console.log(e));
}

export function getEngineerData() {
    axios.get('/zhgd/index/engineerManagement')
        .then(data => {
            dshStore.setEngineerings(data.result);
        })
        .catch(e => console.log(e));
}

export function getProject() {
    axios.get('/zhgd/index/projectDemeanor')
        .then(data => {
            dshStore.setProjects(data.result);
        })
        .catch(e => console.log(e));
}

export function getMap() {
    axios.get('/zhgd/index/mapInfo')
        .then(data => {
            dshStore.setMapdata(data.result);
        })
        .catch(e => console.log(e));
}
